import { Card } from '@components/primitives/Card.js'
import { Button } from '@components/primitives/Button.js'
import { Alert } from '@components/primitives/Alert.js'
import { formatDatetime } from '@utils/format.js'
import { precisaBackup } from '@services/backup.js'
import type { ConfigPageState } from './useConfigPage.js'

type Props = Pick<
  ConfigPageState,
  'ultimoBackup' | 'backupMsg' | 'fileInputRef' | 'handleExportarBackup' | 'handleSelecionarImport'
>

export function BackupSection({
  ultimoBackup,
  backupMsg,
  fileInputRef,
  handleExportarBackup,
  handleSelecionarImport,
}: Props) {
  return (
    <>
      {precisaBackup() && (
        <Alert
          variant='warning'
          title='Hora de fazer backup!'
          message={
            ultimoBackup
              ? `Seu último backup foi em ${formatDatetime(ultimoBackup)}. Exporte agora para proteger seus dados.`
              : 'Você ainda não fez nenhum backup. Exporte agora para proteger seus dados.'
          }
        />
      )}

      {backupMsg && <Alert variant='success' title={backupMsg} message='' />}

      <Card surface='raised'>
        <div className='cf3-config-section'>
          <p className='cf3-config-section__title'>Backup de Dados</p>
          <p className='cf3-config-section__desc'>
            Seus dados ficam salvos somente neste aparelho. Exporte um backup regularmente (inclui
            PDFs e fotos anexados) para não perder seus registros.
          </p>

          {ultimoBackup && (
            <p className='cf3-config-backup-meta'>Último backup: {formatDatetime(ultimoBackup)}</p>
          )}

          <div className='cf3-config-section__actions cf3-config-section__actions--row'>
            <Button variant='secondary' onClick={handleExportarBackup}>
              Exportar backup
            </Button>
            <Button variant='secondary' onClick={() => fileInputRef.current?.click()}>
              Importar backup
            </Button>
            <input
              ref={fileInputRef}
              type='file'
              accept='.zip,application/zip'
              className='cf3-config-file-input'
              onChange={handleSelecionarImport}
            />
          </div>
        </div>
      </Card>
    </>
  )
}
